import { createBreakpoints } from '@mui/system';
import { createTheme } from '@mui/material/styles';

export const customColorPalette = {
  blueGrey: '#D9E0E7',
  blueGreyLight: '#EEF3F8',
  blueGreyMedium: '#DBDFE3',
  blueGreyDark: '#454E5E',
  cerulean: '#00a8d7',
};

const breakpoints = createBreakpoints({});

// Define spacing scale
const spacing = {
  xs: '4px', // 0.25rem
  sm: '8px', // 0.5rem
  md: '16px', // 1rem
  lg: '24px', // 1.5rem
  xl: '32px', // 2rem
  xxl: '48px', // 3rem
};

export const proAccountThemeCoreUI = createTheme({
  spacing: (factor: number) => {
    // Convert numeric factors to our custom spacing scale
    const spacingMap = {
      0: '0',
      0.5: spacing.xs,
      1: spacing.sm,
      2: spacing.md,
      3: spacing.lg,
      4: spacing.xl,
      6: spacing.xxl,
    };
    return spacingMap[factor as keyof typeof spacingMap] || `${factor * 8}px`;
  },
  typography: {
    fontFamily: ['Inter', 'sans-serif'].join(','),
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: '3.5rem',
      letterSpacing: '-0.5px',
      [breakpoints.down('sm')]: {
        fontSize: '1.75rem',
        lineHeight: '2.25rem',
      },
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.375rem',
      lineHeight: '3.375rem',
      letterSpacing: '-0.5px',
      [breakpoints.down('sm')]: {
        fontSize: '1.5rem',
        lineHeight: '2.125rem',
      },
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.75rem',
      lineHeight: '2.375rem',
      letterSpacing: '-0.5px',
      [breakpoints.down('sm')]: {
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        letterSpacing: '-0.2px',
      },
    },
    h4: {
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: '2.125rem',
      letterSpacing: '-0.5px',
      [breakpoints.down('sm')]: {
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        letterSpacing: '-0.2px',
      },
      marginBlockStart: '1em',
      marginBlockEnd: '1em',
    },
    h5: {
      fontWeight: 700,
      fontSize: '1.25rem',
      lineHeight: '1.75rem',
      letterSpacing: '-0.2px',
      [breakpoints.down('sm')]: {
        fontSize: '1rem',
        lineHeight: '1.625rem',
      },
      marginBlockStart: '1em',
      marginBlockEnd: '1em',
    },
    h6: {
      fontWeight: 700,
      fontSize: '1rem',
      letterSpacing: '-0.2px',
      lineHeight: '1.625rem',
      marginBlockStart: '1em',
      marginBlockEnd: '1em',
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
    },
    body2: {
      fontSize: '0.75rem',
      lineHeight: '1.25rem',
    },
  },
  palette: {
    primary: {
      main: '#145885',
      dark: '#232736',
    },
    secondary: {
      main: '#475D6E',
    },
    error: {
      main: '#F44336',
      dark: '#B20E0B',
    },
    warning: {
      main: '#F9845D',
      dark: '#AB5E00',
    },
    success: {
      main: '#2E7D32',
      light: '#32C370',
      dark: '#00834F',
    },
    text: {
      primary: '#343538',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          letterSpacing: '-0.2px',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#000000',
            backgroundColor: '#FFFFFF',
          },
          '&.inverted': {
            color: '#000000',
            backgroundColor: '#FFFFFF',
          },
          '&.Mui-selected.inverted': {
            color: '#343538',
            backgroundColor: customColorPalette.blueGreyLight,
          },
          '& + .MuiTab-root': {
            marginLeft: '8px',
          },

          textTransform: 'none',
          height: '48px',
          width: '140px',
          border: '1px solid #DBDFE3',
          borderRadius: '4px 4px 0 0',
          color: '#343538',
          backgroundColor: customColorPalette.blueGreyLight,
          borderBottom: 'none',
          '@media screen and (min-width: 900px)': {
            width: '200px',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          '& .MuiTabScrollButton-root.Mui-disabled': {
            opacity: 0.3,
          },
        },
        indicator: {
          display: 'none',
        },
      },
    },
  },
});
